import useOnOutsideClick from './useOnOutsideClick';

export default useOnOutsideClick;
